import { render, staticRenderFns } from "./settingInterfaceEdit.vue?vue&type=template&id=9653f72a&scoped=true&"
import script from "./settingInterfaceEdit.vue?vue&type=script&lang=js&"
export * from "./settingInterfaceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9653f72a",
  null
  
)

export default component.exports